import './init';
import { ConfigurationContext } from './components/Configuration/Configuration';
import { ModalManagerContext } from './components/Modal/Contexts';
import { ToasterContext } from './components/Toaster/Context';
import { LiveLogContext } from './components/LiveLog/Context';

if (typeof window !== 'undefined') {
  window.cosmos.configurationContext = ConfigurationContext;
  window.cosmos.modalManagerContext = ModalManagerContext;
  window.cosmos.toasterContext = ToasterContext;
  window.cosmos.liveLogContext = LiveLogContext;
}
